import React from 'react'
import { context, formatDate, request } from '@tools/wr-catalog-base'
import { trackPageAction } from '@utils/tracking'
import getCatalogHtmlTemplate from '@routes/List/catalogHtmlTemplate'

import { StyledExportButton } from './styles'

const ExportButton = ({ getRegionName, isCatalogExportLoading, setCatalogExportLoading }) => {
  const exportCatalog = async () => {
    const {
      state: { catalogs },
    } = context
    const catalog = catalogs[0]
    const renderingContext = {
      items: catalog.contents.items,
    }

    const html = await getCatalogHtmlTemplate(renderingContext)
    const fileName = `Success Point Services - ${context.utils.getRegionName()} - ${formatDate('M/D/YYYY')(
      new Date(),
    )}.pdf`.replace(/\//g, '-')
    const data = await request({
      url: `${context.constants.appHost}/api/v1/documents/export`,
      method: 'POST',
      body: JSON.stringify({
        data: {
          html,
          options: {
            media: 'print',
            landscape: true,
            preferCSSPageSize: true,
            appendPageNumbers: true,
            pageNumberOptions: {
              kx: 1,
              dx: -30,
              dy: 14,
              size: 12.5,
            },
          },
        },
      }),
    })

    try {
      const file = new window.File([data], fileName, { type: 'application/pdf' })
      const blobUrl = window.URL.createObjectURL(file)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName
      link.click()

      window.URL.revokeObjectURL(blobUrl)
    } catch (e) {
      try {
        const textFileAsBlob = new window.Blob([data], { type: 'application/pdf' })
        window.navigator.msSaveBlob(textFileAsBlob, fileName)
      } catch (e2) {
        console.error(e)
        console.error('pdf preview error')
      }
    }
  }

  return (
    <StyledExportButton
      disabled={isCatalogExportLoading || !getRegionName()}
      onClick={() => {
        trackPageAction('click', 'main-page-control', 'Export')
        setCatalogExportLoading(true)

        exportCatalog().finally(() => setCatalogExportLoading(false))
      }}
      primary
    >
      Export
    </StyledExportButton>
  )
}

export default ExportButton
